import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {Scrollbars} from 'react-custom-scrollbars';

export default class _ScrollBars extends Component {
    static propTypes = {
        onScroll: PropTypes.func
    };

    render() {
        const {onScroll} = this.props;

        return (
            <Scrollbars ref='scrollbars'
                        style={{flex: 1}}
                        onScroll={onScroll}>
                {this.props.children}
            </Scrollbars>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/ScrollBars.jsx